import React from 'react';
import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  HelpOutline as GapIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { KnowledgeGap } from '../../types/decision.types';

interface KnowledgeGapPanelProps {
  gaps: KnowledgeGap[];
  onSearchGap?: (suggestedSearch: string) => void;
}

const KnowledgeGapPanel: React.FC<KnowledgeGapPanelProps> = ({ gaps, onSearchGap }) => {
  if (gaps.length === 0) {
    return (
      <div style={{ padding: 16, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No significant knowledge gaps identified.
        </Typography>
      </div>
    );
  }

  return (
    <div>
      <Typography variant="subtitle2" style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 4, color: 'rgba(0,0,0,0.6)' }}>
        Topics with insufficient evidence ({gaps.length})
      </Typography>
      <List dense disablePadding>
        {gaps.map((gap, index) => (
          <ListItem key={index} style={{ paddingTop: 4, paddingBottom: 4 }}>
            <ListItemIcon style={{ minWidth: 32 }}>
              <GapIcon fontSize="small" color="warning" />
            </ListItemIcon>
            <ListItemText
              primary={gap.topic}
              secondary={gap.description}
              primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
              secondaryTypographyProps={{ variant: 'caption' }}
            />
            {onSearchGap && (
              <ListItemSecondaryAction>
                <Tooltip title={`Search: "${gap.suggestedSearch}"`}>
                  <IconButton
                    size="small"
                    onClick={() => onSearchGap(gap.suggestedSearch)}
                  >
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            )}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default KnowledgeGapPanel;
